var _title, _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlanned = function SvgPlanned(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "style-two-pin-star")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round",
    d: "M12,0A9.511,9.511,0,0,0,2.5,9.5c0,6.547,6.538,12.488,8.541,14.153a1.5,1.5,0,0,0,1.917,0c2-1.665,8.542-7.608,8.542-14.154A9.511,9.511,0,0,0,12,0Zm4.366,7.627A.613.613,0,0,1,16.8,8.7l-1.921,1.894a.5.5,0,0,0-.108.556l1.064,2.446a.654.654,0,0,1-.931.819l-2.655-1.5a.5.5,0,0,0-.491,0L9.1,14.412a.654.654,0,0,1-.931-.819l1.063-2.446a.5.5,0,0,0-.107-.556L7.2,8.7a.613.613,0,0,1,.429-1.07H9.808a.5.5,0,0,0,.454-.289l1.15-2.48a.662.662,0,0,1,1.177,0l1.147,2.48a.5.5,0,0,0,.454.289Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0A9.511,9.511,0,0,0,2.5,9.5c0,6.547,6.538,12.488,8.541,14.153a1.5,1.5,0,0,0,1.917,0c2-1.665,8.542-7.608,8.542-14.154A9.511,9.511,0,0,0,12,0Zm4.366,7.627A.613.613,0,0,1,16.8,8.7l-1.921,1.894a.5.5,0,0,0-.108.556l1.064,2.446a.654.654,0,0,1-.931.819l-2.655-1.5a.5.5,0,0,0-.491,0L9.1,14.412a.654.654,0,0,1-.931-.819l1.063-2.446a.5.5,0,0,0-.107-.556L7.2,8.7a.613.613,0,0,1,.429-1.07H9.808a.5.5,0,0,0,.454-.289l1.15-2.48a.662.662,0,0,1,1.177,0l1.147,2.48a.5.5,0,0,0,.454.289Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlanned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/planned.9b619b05.svg";
export { ForwardRef as ReactComponent };